import { withModalProvider } from "../../hoc/withModalProvider";
import { QuestionRemovalModal as View, IProps } from "./QuestionRemovalModal";

export const QuestionRemovalModal = withModalProvider<IProps>(View);
